<template>
    <div id="index">
        <div class="visible-xs">
            <div class="head_div flex_start">
                <i @click.stop="goLogin">
                    <img src="@/assets/img/esc_fan.png" alt="">
                </i>
            </div>
            <div class="logo_div">
                <h4 class="title">输入验证码</h4>
                <div class="prompt_top">
                    已发送4位验证码至 <span>{{phone}}</span>
                </div>
                <div class="user_num">
                    <input type="Number" autofocus="autofocus" v-model="code_num" placeholder="">
                    <div class="code_ul flex_between">
                        <span class="code_li flex_center" :class="{'selected':code_num.length>0}">{{code_num[0]}}</span>
                        <span class="code_li flex_center" :class="{'selected':code_num.length>1}">{{code_num[1]}}</span>
                        <span class="code_li flex_center" :class="{'selected':code_num.length>2}">{{code_num[2]}}</span>
                        <span class="code_li flex_center" :class="{'selected':code_num.length>3}">{{code_num[3]}}</span>
                    </div>
                </div>
                <button class="login" @click="login">确认</button>
                <div class="flex_center prompt">
                    <a @click.stop="getCode" href="javaScript:void(0)">重新获取</a>
                    <span v-if="code>0">{{code}}s</span>
                </div>
            </div>
        </div>
        <div class="popup"  v-if="login_index">
            <div class="popup_div cover_img">
                <div class="successfully">
                    <h4 class="flex_center successfully_title">
                    <i><img src="@/assets/img/successfully.png" alt="" /></i>
                    恭喜注册成功!
                    </h4>
                    <div class="successfully_text">
                    恭喜您注册成功“麻醉眼界”会员，您的手机即为您的登录账号
                    </div>
                    <div class="go_login flex_center registered">
                    {{ returnNum }}s后跳转
                    <a href="javaScript:void(0)" @click.stop="goLogin">登录</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import "@/assets/js/swiper.animate1.0.3.min.js";
    import "@/assets/css/animate.min.css";
    import "@/assets/css/video-js.min.css";

    export default {
        name: "index",
        data() {
            return {
                IMG_URL: this.$IMG_URL,
                type: 0,//1登录  2注册  3修改密码 4绑定手机
                code: 0,//验证码获取倒计时
                code_num: '',//手机验证码
                login_index:0,
                returnNum:0,
                is_repeat:0,
                phone: '',//手机号码
                password: '',//密码
                invitation: '',//邀请码
                basic: {},//基本信息
            };
        },
        computed: {},
        components: {

        },
        watch: {
            code_num: function (eve, res) {
                 
                if (this.code_num.length > 4) {
                    this.code_num = res;
                }
            }
        },
        methods: {
             returnFun() {
                //返回登录倒计时方法
                let that = this;
                that.returnNum = 3;
                let retirnSte = setInterval(() => {
                    that.returnNum--;
                    if (that.returnNum <= 0) {
                    clearInterval(retirnSte);
                    that.$router.replace({ path: '/m_password' });
                }
                }, 1000);
            },
            goLogin() {//返回登录
                if (this.$store.state.query_url) {
                    this.$router.replace({ name: this.$store.state.query_url });
                } else {
                    this.$router.go(-1);
                }
            },

            login() {
                if (this.code_num == '' || !this.code_num) {
                    layer.open({
                        content: "请输入手机验证码",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.code_num.length !== 4) {
                    layer.open({
                        content: "手机验证码不为4位",
                        time: true,
                        skin: "msg"
                    });
                    return false;
                }
                if (this.type == 1) {//登录
                    this.userLogin();
                }
                if (this.type == 2) {//注册
                    this.registered();
                }
                if (this.type == 3) {//修改密码
                    this.modify();
                }
                if (this.type == 4) {//绑定手机
                    this.binding();
                }
            },
            binding() {//绑定手机
                let that = this;
                this.$post('user_modify', {
                    mobile: this.phone,
                    code: this.code_num,
                    member_id: this.USER().id,
                }).then(res => {
                    if (res.code == 200) {
                        layer.open({
                            content: "绑定成功！",
                            time: 2,
                            skin: "msg"
                        });
                        res.data.token = res.data.refresh_token;
                        that.SET_USER(res.data);
                        setTimeout(() => {
                            if (that.$store.state.query_url) {
                                that.$router.replace({ path: that.$store.state.query_url });
                            } else {
                                that.$router.replace({ path: '/m_password' });
                            }
                        }, 2000)
                    }
                }).catch(res => {
                     
                    layer.open({
                        content: res.message,
                        time: 1,
                        skin: "msg"
                    });
                })
            },
            goLogin(){
                this.$router.replace({ path: '/m_password' });
            },
            modify() {//修改密码
                let that = this;
                this.$post('repassword', {
                    mobile: this.phone,
                    password: this.password,
                    repassword: this.password,
                    code: this.code_num
                }).then(res => {
                    layer.open({
                        content: "修改成功！",
                        time: true,
                        skin: "msg"
                    });
                    that.$store.commit('setPassword', '');
                    if (that.$store.state.query_url) {
                        res.data.token = res.data.refresh_token;
                        that.SET_USER(res.data);
                    }
                    setTimeout(() => {
                        if (that.$store.state.query_url) {
                            that.$router.replace({ path: that.$store.state.query_url });
                        } else {
                            that.$router.replace({ path: '/m_password' });
                        }

                    }, 1000)
                }).catch(res => {
                     
                    layer.open({
                        content: res.message,
                        time: true,
                        skin: "msg"
                    });
                })
            },
            registered() {//注册
                let that = this;
                this.is_repeat = this.$store.state.is_repeat
                this.$post('mobile_register', {
                    mobile: this.phone,
                    password: this.password,
                    repassword: this.password,
                    code: this.code_num,
                    company: this.basic.company,
                    username: this.basic.username,
                    realname: this.basic.realname,
                    invite: this.invitation,
                    professor: this.basic.professor,
                    office: this.basic.office,
                    email:this.basic.email,
                    address:this.basic.address,
                    cert:this.basic.cert,
                    check_status:0
                }).then(res => {
                    if(that.is_repeat == 1){
                        layer.open({
                            content: "重新提交成功",
                            time: true,
                            skin: "msg"
                        });
                        that.REFRESH_USER()
                        that.$store.commit('setPassword', '')
                        that.$store.commit('setInvitation', '')
                        that.$store.commit('setBasic', {})
                        that.$store.commit('setPhone',this.phone,)
                        that.$router.replace({ path: '/m_my' });
                    }else{
                        layer.open({
                            content: "注册成功！",
                            time: true,
                            skin: "msg"
                        });
                            that.SET_USER(res.data);
                            that.$store.commit('setPassword', '')
                            that.$store.commit('setInvitation', '')
                            that.$store.commit('setBasic', {})
                            that.$store.commit('setPhone','')
                            setTimeout(() => {
                            that.login_index = 1;
                        },1000);
                    }
                   
                    // setTimeout(() => {
                    //     that.login_index = 1;
                    //     if (that.$store.state.query_url) {
                    //         that.$router.replace({ path: that.$store.state.query_url});
                    //     } else {
                    //         that.$router.replace({ path: '/m_password' });
                    //     }
                    // }, 1000)
                }).catch(res => {
                    layer.open({
                        content: res.message,
                        time: true,
                        skin: "msg"
                    });
                    setTimeout(() => {
                        that.goLogin();
                    }, 1000)
                })
            },
            //账号登录
            userLogin() {
                let that = this;
                this.$post('mobile_login', {
                    mobile: this.phone,
                    code: this.code_num
                }).then(res => {
                    layer.open({
                        content: "登录成功！",
                        time: true,
                        skin: "msg"
                    });
                    that.SET_USER(res.data);
                    setTimeout(() => {
                        if (that.USER().unionid == '' || !that.USER().unionid) {
                            layer.open({
                                content: '亲，绑定微信后可以显示微信头像，现在就去绑定？'
                                , style: 'background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;' //自定风格
                                , btn: ['确定', '取消']
                                , yes: function (index) {
                                    layer.close(index);
                                    that.$router.replace({ path: '/m_setUp' });
                                }, no: function (index) {
                                    layer.close(index);
                                    if (that.$store.state.query_url) {
                                        that.$router.replace({ path: that.$store.state.query_url});
                                    } else {
                                        that.$router.replace({ path: '/m_index' });
                                    }
                                }
                            });
                        } else {
                            if (that.$store.state.query_url) {
                                that.$router.replace({ path: that.$store.state.query_url});
                            } else {
                                that.$router.replace({ path: '/m_index' });
                            }
                        }
                    }, 1000)

                }).catch(res => {
                     
                    layer.open({
                        content: res.message,
                        time: true,
                        skin: "msg"
                    });
                })
            },
            // 判断完毕后加载样式
            setActiveStyleSheet(filename) {
                document.write("<link href=" + filename + " rel=stylesheet>");
            },
            getCode() {//获取code
                let that = this;
                this.$post('code', {
                    mobile: this.phone
                }).then(res => {
                     
                    layer.open({
                        content: "发送成功，请注意查收！",
                        time: true,
                        skin: "msg"
                    });
                    that.code = 60;
                    let code_set = setInterval(() => {
                        that.code--;
                        if (that.code <= 0) {
                            clearInterval(code_set);
                        }
                    }, 1000)
                }).catch(res => {
                     
                    layer.open({
                        content: res.message,
                        time: true,
                        skin: "msg"
                    });
                })
            },

        },
        watch: {
            login_index: function (eve) {
                this.returnFun();
            },
        },
        mounted() {
            let that = this;
            this.getShare();
            if (this._isMobile()) {
                // alert("手机端");
                //   this.$router.replace('/m_index');
            } else {
                // alert("pc端");
                this.$router.replace("/");
            }
            this.type = that.$route.query.type;
            this.phone = this.$store.state.phone;
            this.password = this.$store.state.password;
            this.invitation = this.$store.state.invitation;
            this.basic = this.$store.state.basic;
            this.getCode();


            // window.onload = function () {
            //     var w = document.body.clientWidth; //获取屏幕宽度
            //     // 这里*100 是为了取整数
            //     var x = parseInt((w * 100) / 375 * 10) / 10; //获取任意屏幕上的根节点字体大小
            //     document.getElementsByTagName('html')[0].style.fontSize = x + 'px';
            //     //监听屏幕宽度变化
            //     window.onresize = function () {
            //         var w = document.body.clientWidth; //获取屏幕宽度
            //         var x = parseInt((w * 100) / 375 * 10) / 10;; //获取任意屏幕上的根节点字体大小
            //         document.getElementsByTagName('html')[0].style.fontSize = x + 'px';
            //     }
            // }
        }
    };
</script>

<style scoped>
    html,
    body {
        max-width: 100vw;
    }
   
.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.popup .popup_div {
  position: absolute;
  top: 50%;
  width: 300px;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.16);
  padding: 40px 40px;
}

/* 注册弹窗 */
.successfully .successfully_title {
  font-size: 20px;
  color: #333;
}

.successfully_title > i {
  width: 33px;
  margin-right: 13px;
}

.successfully .successfully_text {
  font-size: 14px;
  color: #333;
  margin-top: 18px;
}

.successfully .go_login {
  margin-top: 40px;
  font-size: 12px;
  color: #656565;
}
    .visible-xs {
        width: 100vw;
        overflow: hidden;
        padding-top: 0rem;
        padding: 1.6rem 2.4rem;
    }

    .head_div>i {
        width: 1.8rem;
    }

    .logo_div {
        position: fixed;
        top: 8vh;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100vw - 4rem);
    }

    .title {
        margin-top: 5rem;
        font-size: 2rem;
        color: 333;
        font-weight: bold;
    }

    .user_num {
        margin-top: 5.8rem;
        position: relative;
        height: 6.5rem;
    }

    .user_num>input {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        opacity: 0;
    }

    .user_num .code_ul {}

    .user_num .code_ul .code_li {
        width: 6.5rem;
        height: 6.5rem;
        border-radius: .5rem;
        border: .05rem solid #DFDFDF;
        font-size: 2.4rem;
        color: #333333;
        font-weight: bold;
    }

    .user_num .code_ul .code_li.selected {
        border-color: #F24D5B;
    }

    .login {
        width: 100%;
        margin-top: 6vh;
        height: 4.5rem;
        border-radius: 2.2rem;
        background: #F24D5B;
        color: #fff;
        border: 0;
        font-size: 1.8rem;
        box-shadow: 0 0 2.7rem rgba(241, 77, 91, 0.3);
    }

    .prompt_top {
        margin-top: 1.8rem;
        color: #666;
        font-size: 1.3rem;
    }

    .prompt_top>span {
        color: #F24D5B;

    }

    .prompt {
        margin-top: 3.7rem;
        font-size: 1.3rem;
        color: #656565
    }

    .prompt>span {
        color: #F14D5B;
        margin-left: 1rem;
    }

    .wx_logo {
        position: fixed;
        bottom: 3rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
    }

    .wx_logo .wx_text {
        font-size: 1.2rem;
        color: #BABFC0;
        position: relative;
    }

    .wx_logo .wx_text::after {
        content: '';
        position: absolute;
        left: -10rem;
        top: 50%;
        transform: translateY(-50%);
        width: 8.8rem;
        height: .05rem;
        background: #DFDFDF;
    }

    .wx_logo .wx_text::before {
        content: '';
        position: absolute;
        right: -10rem;
        top: 50%;
        transform: translateY(50%);
        width: 8.8rem;
        height: .05rem;
        background: #DFDFDF;
    }

    .wx_logo>i {
        width: 4rem;
        margin: 1.7rem auto 0 auto;

    }


    .visible-xs {
        width: 100vw;
        overflow: hidden;
        padding-top: 0rem;
        padding: 1.6rem 2.4rem 15rem 2.4rem;
        min-height: calc(100vh - 16.6rem);
    }

    .logo_div {
        position: relative;
        top: 0;
        left: 0;
        transform: translateX(0);
        margin-top: .25rem;
        width: calc(100vw - 4rem);
    }

    .wx_logo {
        position: absolute;
        bottom: 3rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/minLogin/m_code.vue